"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VACCINATION_TYPE_DISPLAY_NAMES = void 0;
exports.VACCINATION_TYPE_DISPLAY_NAMES = {
    COVID_19: 'Covid-19',
    INFLUENZA: 'Annual Influenza (Flu)',
    MEASLES_MUMPS_RUBELLA: 'MMR (Measles, Mumps, Rubella)',
    VARICELLA: 'Varicella (Chickenpox)',
    HEPATITIS: 'Hepatitis B',
    TDAP: 'Tdap',
};
//# sourceMappingURL=vaccination-display-labels.js.map